angular.module('rjmNg.directives').directive 'pathColumnSelect', [
  () ->
    restrict:"E"
    templateUrl: "directive.pathColumnSelect.html"
    priority: 200
    replace: false
    scope:
      selected: '='
      direction: '@'
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "notification"
      "StructureCache"
      (
        notification
        StructureCache
      ) ->
        view = @
        view.structure = null
        view.references = null
        view.loading = true
        view.search =
          column: ''
          table: ''
        view.tables = []
        view.columns = []
        view.dropdownButtonText = null
        view.restrictedColumns = {}

        _getAllTables = (tableMap) ->
          (value for key, value of tableMap)

        view.updateColumns = () ->
          if view.selected?.table? and view.structure?
            view.columns = view.structure.tables[view.selected.table].columns

        view.setTables = () ->
          view.tables = _getAllTables(view.structure.tables)

        view.getStructure = () ->
          StructureCache.getStructureAndReferences().then(
            (result) ->
              view.structure = result.structure
              view.references = result.references.references
              view.updateState()
              view.updateColumns()
              view.setTables()
              view.loading = false
            , (error) ->
              notification.error "", "Error loading structure.", "data-warehouse-notifications"
              view.loading = false
          )

        view.selectTable = ($event, table) ->
          view.selected.table = table.id
          view.selected.column = null

        view.selectColumn = (column) ->
          view.selected.column = column.id
          view.search.column = ''
          view.search.table = ''

        view.updateState = () ->
          return unless view.structure?

          # Name of the button for selecting table
          if view.selected.table?
            view.dropdownButtonText = view.structure.tables[view.selected.table].name
          else
            view.dropdownButtonText = "Select Table"

        # Disables any columns that are restricted from selection
        # because they is already an existing path for them
        view.setRestrictedColumns = (selections) ->
          view.restrictedColumns = {}
          otherDirection = if view.direction is "from" then "to" else "from"
          otherSelection = selections[otherDirection]

          # if no column is selected on the other direction
          # and no table is yet selected for this direction
          # then we can skip the rest (no conflict is yet possible)
          unless otherSelection?.column? and view.selected.table?
            return

          # find all references that we need to prevent from
          # creating again
          referencesToRestrict = view.references.filter (r) ->
            r[otherDirection].column is otherSelection.column

          for ref in referencesToRestrict
            view.restrictedColumns[ref[view.direction].column] = true

        view.filterTableType = (table) ->
          return table.type in ["view","standard"]

        @$onInit = ->
          view.selected ?=
            table: null
            column: null
          view.getStructure()

        view
    ]
    link: (scope, elem, attrs, rjmUi) ->
      view = scope.view
      scope.$watch 'view.selected.table', () ->
        view.search.column = ''
        view.updateColumns()
        view.updateState()

      scope.$watchGroup [
        'view.selected.table'
        'view.selected.column'
      ], view.updateState

      scope.$on 'updateColumnsSelectionRestrictions', (event, selections) ->
        view.setRestrictedColumns(selections)

      # Listen to see if anyone has possibly updated the structure cache,
      # especially the reference editor
      scope.$on 'view.structureCacheUpdated', () ->
        view.getStructure()

      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "data-warehouse", view.loading

]
